module.exports = __webpack_public_path__ + "img/Colorization5.75429482.webp";